import DatabaseSteps from './DatabaseSteps';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';
import {
  CatalogProductAssociation,
  MerchantCatalogProduct,
  ProductWithVariants,
  VariantsWithPrice,
} from 'src/app/api/openapi';
import { CatalogProductsClient } from 'src/app/api/clients/catalogProducts';

export interface AddFromDatabaseFormValues {
  activeStep: number;
  products: ProductWithVariants[];
  productsWithPrices: (MerchantCatalogProduct | VariantsWithPrice)[];
  selectedProductIds: Record<string, boolean>;
}

const AddProductsFromDatabase = () => {
  const { merchantId, catalogId } = useParams();

  const handleAddProducts = (values: AddFromDatabaseFormValues) => {
    if (!merchantId || !catalogId) return;
    const payload: CatalogProductAssociation[] = values.products.map(
      ({ id, variants }) => ({
        product: {
          id,
          variants: variants.map((variant: any) => ({
            id: variant.id,
            price: {
              amount: Number(
                (
                  values.productsWithPrices.find(
                    (row: any) => row.id === variant.id
                  ) as VariantsWithPrice
                )?.price
              ),
              currency_code: 'USD',
            },
          })),
        },
      })
    );
    return CatalogProductsClient.bulkAddProductsMerchantCatalog(
      merchantId,
      catalogId,
      payload
    );
  };

  return (
    <Formik
      initialValues={
        {
          activeStep: 0,
          products: [],
          productsWithPrices: [],
          selectedProductIds: {},
        } as AddFromDatabaseFormValues
      }
      onSubmit={handleAddProducts}
    >
      {DatabaseSteps}
    </Formik>
  );
};

export default AddProductsFromDatabase;
